// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-red {
  color: var(--elem-red-color);
}
.color-green {
  color: green;
}
.color-blue {
  color: var(--toolbtn-active-color);
}
body {
  overflow-y: hidden;
  color: var(--main-body-color);
  font-size: var(--messageFontSize);
}
body * {
  overflow-anchor: none;
}
#side {
  transition: width 0.2s;
}
#side.sideVisible {
  display: initial;
  width: calc(var(--vw) * 100);
  min-width: 325px;
}
#side.fullCompactMode #side:not(.sideVisible) {
  width: 100%;
  min-width: auto;
  overflow-x: auto;
}
#side.hidden-side {
  width: 0;
}
#side.hidden-side .global-search-wrapper {
  display: none !important;
}
#side.hidden-side .chat-list {
  display: none !important;
}
#side.hidden-side .header-btns {
  display: none !important;
}
#side.hidden-side .radio-btns {
  display: none !important;
}
#resize-divider {
  height: 100%;
  width: 1px;
  cursor: initial;
  background-color: var(--main-block-border-left);
}
#resize-divider.compactMode {
  display: initial;
  cursor: col-resize;
  padding-right: 1px;
}
#resize-divider.fullCompactMode {
  display: none;
}
.main-block {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.main-content {
  overflow-y: auto;
  display: flex;
  width: 100%;
  flex: 1 1;
  background: var(--bg-color2);
}
.main-body {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  width: 100%;
  overflow-x: hidden;
  -webkit-overflow-scrolling: auto !important;
}
#main-header-comp {
  width: 100%;
}
.main-header-info {
  display: flex;
  flex-grow: 1;
  user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
}
.main-header-info .header-text {
  display: flex;
}
.main-header-info .header-text .header-main {
  margin-left: 15px;
  overflow: hidden;
}
.main-header-info .header-text .header-main > * {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.main-header-info .header-text .header-main .sub-text {
  color: var(--message-grey-color);
  font-size: 14px;
}
.contact-status-text {
  text-align: left;
}
.contact-buttons-block {
  display: flex;
  flex-direction: row;
}
.contact-buttons-block i {
  margin: auto 5px;
  color: #5f5959;
}
.contact-buttons-block button {
  margin: auto 5px;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 5px;
  background: #f0f0f0;
  color: #ccc;
  outline: none;
  font-size: 1em;
}
.contact-buttons-block button:hover {
  color: #ffffff;
}
.contact-buttons-block i.fa-window-maximize,
.contact-buttons-block i.fa-phone {
  margin-left: 10px;
  color: var(--toolbtn-color);
}
.contact-buttons-block i.fa-window-maximize:not(.disabled):hover,
.contact-buttons-block i.fa-phone:not(.disabled):hover {
  color: var(--toolbtn-color-hover) !important;
}
.contact-buttons-block i.fa-window-maximize {
  font-size: 21px;
  z-index: 0;
}
.message-list-preload {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}
.forward span {
  display: flex;
  flex-direction: column;
}
.forward span.fwd {
  font-size: .9em;
  color: var(--fwd-message-color);
  filter: contrast(var(--fontContrast));
}
.forward span.fwd.title {
  display: flex;
  flex-direction: row;
  height: 1em;
  margin-bottom: 0.4em;
}
.forward span.fwd.title i {
  margin-top: 0.4em;
  margin-right: 0.2em;
}
.message-send:hover,
.clip:hover,
.header-btns:hover {
  color: var(--toolbtn-color-hover);
}
.modal-body {
  padding: 0;
}
._hidden {
  visibility: hidden;
}
.message-btn-wrapper {
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.message-btn {
  position: relative;
  width: 40px;
  min-width: 40px;
  height: 40px;
  display: inline-flex;
  background-color: #76a7f3;
  border-radius: 50%;
  margin: auto;
}
.message-btn i {
  color: #fff;
  margin: auto;
  font-size: 20px;
}
.pending {
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #c8c8c8ba;
}
.dowload-abort-btn,
.upload-abort-btn {
  margin: auto;
  z-index: 2;
}
.dowload-abort-btn i,
.upload-abort-btn i {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.dowload-abort-btn .circular-chart,
.upload-abort-btn .circular-chart {
  border-radius: 50%;
  transform: rotate(-90deg);
  fill: none;
}
.dowload-abort-btn .circular-chart .progress__value,
.upload-abort-btn .circular-chart .progress__value {
  stroke: #fff;
  stroke-linecap: round;
}
.message-btn {
  cursor: pointer;
}
.message-btn i.fa-play {
  transform: translate(11%);
}
.side-header {
  background-color: var(--bg-color) !important;
}
@keyframes size {
  from {
    width: 0;
    height: 0;
  }
  to {
    width: 35px;
    height: 35px;
  }
}
.circle-animation {
  display: flex;
  border-radius: 50%;
  position: relative;
  margin: auto;
  width: 40px;
  height: 40px;
  color: var(--toolbtn-color);
}
.circle-animation:active::after {
  animation: size 160ms ease-out forwards;
  -moz-animation: size 160ms ease-out;
  content: " ";
  display: block;
  background: var(--circle-animation-bgcolor);
  position: absolute;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}
.circle-animation > * {
  margin: auto;
  z-index: 0;
}
.circle-animation svg {
  fill: var(--toolbtn-color);
}
.circle-animation svg:not(.disabled):hover {
  fill: var(--toolbtn-color-hover);
}
.circle-animation i {
  color: var(--toolbtn-color);
}
.circle-animation i :hover {
  color: var(--toolbtn-color-hover);
}
.circle-animation .circle-animation:active::after {
  animation: size 160ms ease-out forwards;
  -moz-animation: size 160ms ease-out;
  content: " ";
  display: block;
  background: var(--circle-animation-bgcolor);
  position: absolute;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.circle-animation:hover {
  color: var(--circle-animation-hover);
  border-color: var(--circle-animation-hover);
}
.circle-animation:hover .bot-keyboard-btn-square {
  background-color: var(--circle-animation-hover);
}
.circle-animation i {
  color: inherit;
  font-size: inherit;
  line-height: 7px;
  z-index: 0;
}
.channel-footer {
  display: flex;
  height: 50px;
  border-top: 1px solid #ccc;
  background-color: #ffffff;
}
.channel-footer .channel-btn {
  height: 100%;
  background-color: #f2f2f2;
  flex: 1;
  font-size: 18px;
  display: flex;
  color: black;
  cursor: pointer;
}
.channel-footer .channel-btn:hover {
  background-color: #d3d5d3;
}
.channel-footer .channel-btn span {
  margin: auto;
}
.channel-footer .new-publication-btn {
  margin: auto;
  width: 90%;
  max-width: 550px;
}
.message-wrapper {
  display: flex;
}
.message-wrapper .message-list-item {
  position: relative;
  width: 100%;
}
.message-wrapper .message-list-item .message-body .codeblock {
  background-color: #373d42 !important;
  padding: 0 0em 0.1em 0.25em;
  border-radius: 0.35em;
}
.message-wrapper.message-mouth-right::after {
  transition: all 0.3s;
  content: '';
  position: absolute;
  right: 22px;
  bottom: 16px;
  width: 0;
  height: 0;
  border-bottom: 12px solid;
  border-bottom-color: var(--message-right-bgcolor);
  border-left: 14px solid transparent;
  border-right: 12px solid transparent;
  transform: translate(100%, 100%);
  z-index: 1;
}
.message-wrapper.threads-mouse-over::after {
  border-bottom-color: var(--bg-comments-after-hover);
}
.main-body + #main-content-comp {
  flex: none;
}
#main {
  display: initial;
  visibility: visible;
}
#main.hidden {
  visibility: hidden;
}
#main.compactMode #main:not(.hidden) {
  width: 100%;
  flex: 1;
  overflow-x: auto;
}
#main.fullCompactMode #main:not(.hidden) {
  flex: initial;
}
#main-content-comp {
  flex: 1;
  max-width: 100%;
  min-width: 320px;
}
#info {
  display: initial;
}
#info.compactMode {
  width: 100%;
  overflow-x: auto;
}
#info.compactMode .info-wrapper {
  width: 100%;
  min-width: 260px;
}
#info.compactMode .info-wrapper .transition-wrapper {
  width: 100%;
}
#info.compactMode .htswrapper {
  max-width: 100%;
}
#info.mainHidden .info-wrapper {
  border-left: none;
}
#info.hidden {
  visibility: hidden;
  transition: width 0.2s;
  width: 0 !important;
}
.clipboard-temp {
  opacity: 0;
  position: fixed;
  z-index: -9999;
  pointer-events: none;
}
.alert-confirm span {
  word-break: break-all;
}
.v--modal-overlay .pub-media-viewer {
  border-radius: unset !important;
}
.v--modal-overlay .no-gap-on-top {
  top: 0 !important;
  left: 0 !important;
  border-radius: unset !important;
}
.absolute-input {
  position: absolute;
  z-index: 10;
  bottom: 0;
  width: 100%;
}
.rows-layout {
  position: relative;
}
.rows-layout #disabled {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--disabled-overlay-bg);
  opacity: .5;
  z-index: 9;
  display: none;
}
`, "",{"version":3,"sources":["webpack://./less/main.less"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,UAAU;EACV,eAAe;EACf,+CAA+C;AACjD;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,SAAS;EACT,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;;EAEE,4CAA4C;AAC9C;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,+BAA+B;EAC/B,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;;EAGE,iCAAiC;AACnC;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;AACA;;EAEE,YAAY;EACZ,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ;AACA;;EAEE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE;IACE,QAAQ;IACR,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,YAAY;EACZ,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,YAAY;EACZ,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,2CAA2C;AAC7C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,OAAO;EACP,eAAe;EACf,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,iDAAiD;EACjD,mCAAmC;EACnC,oCAAoC;EACpC,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,mDAAmD;AACrD;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,OAAO;EACP,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sCAAsC;EACtC,WAAW;EACX,UAAU;EACV,aAAa;AACf","sourcesContent":[".color-red {\n  color: var(--elem-red-color);\n}\n.color-green {\n  color: green;\n}\n.color-blue {\n  color: var(--toolbtn-active-color);\n}\nbody {\n  overflow-y: hidden;\n  color: var(--main-body-color);\n  font-size: var(--messageFontSize);\n}\nbody * {\n  overflow-anchor: none;\n}\n#side {\n  transition: width 0.2s;\n}\n#side.sideVisible {\n  display: initial;\n  width: calc(var(--vw) * 100);\n  min-width: 325px;\n}\n#side.fullCompactMode #side:not(.sideVisible) {\n  width: 100%;\n  min-width: auto;\n  overflow-x: auto;\n}\n#side.hidden-side {\n  width: 0;\n}\n#side.hidden-side .global-search-wrapper {\n  display: none !important;\n}\n#side.hidden-side .chat-list {\n  display: none !important;\n}\n#side.hidden-side .header-btns {\n  display: none !important;\n}\n#side.hidden-side .radio-btns {\n  display: none !important;\n}\n#resize-divider {\n  height: 100%;\n  width: 1px;\n  cursor: initial;\n  background-color: var(--main-block-border-left);\n}\n#resize-divider.compactMode {\n  display: initial;\n  cursor: col-resize;\n  padding-right: 1px;\n}\n#resize-divider.fullCompactMode {\n  display: none;\n}\n.main-block {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.main-content {\n  overflow-y: auto;\n  display: flex;\n  width: 100%;\n  flex: 1 1;\n  background: var(--bg-color2);\n}\n.main-body {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  position: relative;\n  width: 100%;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: auto !important;\n}\n#main-header-comp {\n  width: 100%;\n}\n.main-header-info {\n  display: flex;\n  flex-grow: 1;\n  user-select: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  -khtml-user-select: none;\n  -webkit-user-select: none;\n}\n.main-header-info .header-text {\n  display: flex;\n}\n.main-header-info .header-text .header-main {\n  margin-left: 15px;\n  overflow: hidden;\n}\n.main-header-info .header-text .header-main > * {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.main-header-info .header-text .header-main .sub-text {\n  color: var(--message-grey-color);\n  font-size: 14px;\n}\n.contact-status-text {\n  text-align: left;\n}\n.contact-buttons-block {\n  display: flex;\n  flex-direction: row;\n}\n.contact-buttons-block i {\n  margin: auto 5px;\n  color: #5f5959;\n}\n.contact-buttons-block button {\n  margin: auto 5px;\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 5px;\n  background: #f0f0f0;\n  color: #ccc;\n  outline: none;\n  font-size: 1em;\n}\n.contact-buttons-block button:hover {\n  color: #ffffff;\n}\n.contact-buttons-block i.fa-window-maximize,\n.contact-buttons-block i.fa-phone {\n  margin-left: 10px;\n  color: var(--toolbtn-color);\n}\n.contact-buttons-block i.fa-window-maximize:not(.disabled):hover,\n.contact-buttons-block i.fa-phone:not(.disabled):hover {\n  color: var(--toolbtn-color-hover) !important;\n}\n.contact-buttons-block i.fa-window-maximize {\n  font-size: 21px;\n  z-index: 0;\n}\n.message-list-preload {\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n}\n.forward span {\n  display: flex;\n  flex-direction: column;\n}\n.forward span.fwd {\n  font-size: .9em;\n  color: var(--fwd-message-color);\n  filter: contrast(var(--fontContrast));\n}\n.forward span.fwd.title {\n  display: flex;\n  flex-direction: row;\n  height: 1em;\n  margin-bottom: 0.4em;\n}\n.forward span.fwd.title i {\n  margin-top: 0.4em;\n  margin-right: 0.2em;\n}\n.message-send:hover,\n.clip:hover,\n.header-btns:hover {\n  color: var(--toolbtn-color-hover);\n}\n.modal-body {\n  padding: 0;\n}\n._hidden {\n  visibility: hidden;\n}\n.message-btn-wrapper {\n  position: absolute;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.message-btn {\n  position: relative;\n  width: 40px;\n  min-width: 40px;\n  height: 40px;\n  display: inline-flex;\n  background-color: #76a7f3;\n  border-radius: 50%;\n  margin: auto;\n}\n.message-btn i {\n  color: #fff;\n  margin: auto;\n  font-size: 20px;\n}\n.pending {\n  position: absolute;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  background-color: #c8c8c8ba;\n}\n.dowload-abort-btn,\n.upload-abort-btn {\n  margin: auto;\n  z-index: 2;\n}\n.dowload-abort-btn i,\n.upload-abort-btn i {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.dowload-abort-btn .circular-chart,\n.upload-abort-btn .circular-chart {\n  border-radius: 50%;\n  transform: rotate(-90deg);\n  fill: none;\n}\n.dowload-abort-btn .circular-chart .progress__value,\n.upload-abort-btn .circular-chart .progress__value {\n  stroke: #fff;\n  stroke-linecap: round;\n}\n.message-btn {\n  cursor: pointer;\n}\n.message-btn i.fa-play {\n  transform: translate(11%);\n}\n.side-header {\n  background-color: var(--bg-color) !important;\n}\n@keyframes size {\n  from {\n    width: 0;\n    height: 0;\n  }\n  to {\n    width: 35px;\n    height: 35px;\n  }\n}\n.circle-animation {\n  display: flex;\n  border-radius: 50%;\n  position: relative;\n  margin: auto;\n  width: 40px;\n  height: 40px;\n  color: var(--toolbtn-color);\n}\n.circle-animation:active::after {\n  animation: size 160ms ease-out forwards;\n  -moz-animation: size 160ms ease-out;\n  content: \" \";\n  display: block;\n  background: var(--circle-animation-bgcolor);\n  position: absolute;\n  border-radius: 50%;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 0;\n}\n.circle-animation > * {\n  margin: auto;\n  z-index: 0;\n}\n.circle-animation svg {\n  fill: var(--toolbtn-color);\n}\n.circle-animation svg:not(.disabled):hover {\n  fill: var(--toolbtn-color-hover);\n}\n.circle-animation i {\n  color: var(--toolbtn-color);\n}\n.circle-animation i :hover {\n  color: var(--toolbtn-color-hover);\n}\n.circle-animation .circle-animation:active::after {\n  animation: size 160ms ease-out forwards;\n  -moz-animation: size 160ms ease-out;\n  content: \" \";\n  display: block;\n  background: var(--circle-animation-bgcolor);\n  position: absolute;\n  border-radius: 50%;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.circle-animation:hover {\n  color: var(--circle-animation-hover);\n  border-color: var(--circle-animation-hover);\n}\n.circle-animation:hover .bot-keyboard-btn-square {\n  background-color: var(--circle-animation-hover);\n}\n.circle-animation i {\n  color: inherit;\n  font-size: inherit;\n  line-height: 7px;\n  z-index: 0;\n}\n.channel-footer {\n  display: flex;\n  height: 50px;\n  border-top: 1px solid #ccc;\n  background-color: #ffffff;\n}\n.channel-footer .channel-btn {\n  height: 100%;\n  background-color: #f2f2f2;\n  flex: 1;\n  font-size: 18px;\n  display: flex;\n  color: black;\n  cursor: pointer;\n}\n.channel-footer .channel-btn:hover {\n  background-color: #d3d5d3;\n}\n.channel-footer .channel-btn span {\n  margin: auto;\n}\n.channel-footer .new-publication-btn {\n  margin: auto;\n  width: 90%;\n  max-width: 550px;\n}\n.message-wrapper {\n  display: flex;\n}\n.message-wrapper .message-list-item {\n  position: relative;\n  width: 100%;\n}\n.message-wrapper .message-list-item .message-body .codeblock {\n  background-color: #373d42 !important;\n  padding: 0 0em 0.1em 0.25em;\n  border-radius: 0.35em;\n}\n.message-wrapper.message-mouth-right::after {\n  transition: all 0.3s;\n  content: '';\n  position: absolute;\n  right: 22px;\n  bottom: 16px;\n  width: 0;\n  height: 0;\n  border-bottom: 12px solid;\n  border-bottom-color: var(--message-right-bgcolor);\n  border-left: 14px solid transparent;\n  border-right: 12px solid transparent;\n  transform: translate(100%, 100%);\n  z-index: 1;\n}\n.message-wrapper.threads-mouse-over::after {\n  border-bottom-color: var(--bg-comments-after-hover);\n}\n.main-body + #main-content-comp {\n  flex: none;\n}\n#main {\n  display: initial;\n  visibility: visible;\n}\n#main.hidden {\n  visibility: hidden;\n}\n#main.compactMode #main:not(.hidden) {\n  width: 100%;\n  flex: 1;\n  overflow-x: auto;\n}\n#main.fullCompactMode #main:not(.hidden) {\n  flex: initial;\n}\n#main-content-comp {\n  flex: 1;\n  max-width: 100%;\n  min-width: 320px;\n}\n#info {\n  display: initial;\n}\n#info.compactMode {\n  width: 100%;\n  overflow-x: auto;\n}\n#info.compactMode .info-wrapper {\n  width: 100%;\n  min-width: 260px;\n}\n#info.compactMode .info-wrapper .transition-wrapper {\n  width: 100%;\n}\n#info.compactMode .htswrapper {\n  max-width: 100%;\n}\n#info.mainHidden .info-wrapper {\n  border-left: none;\n}\n#info.hidden {\n  visibility: hidden;\n  transition: width 0.2s;\n  width: 0 !important;\n}\n.clipboard-temp {\n  opacity: 0;\n  position: fixed;\n  z-index: -9999;\n  pointer-events: none;\n}\n.alert-confirm span {\n  word-break: break-all;\n}\n.v--modal-overlay .pub-media-viewer {\n  border-radius: unset !important;\n}\n.v--modal-overlay .no-gap-on-top {\n  top: 0 !important;\n  left: 0 !important;\n  border-radius: unset !important;\n}\n.absolute-input {\n  position: absolute;\n  z-index: 10;\n  bottom: 0;\n  width: 100%;\n}\n.rows-layout {\n  position: relative;\n}\n.rows-layout #disabled {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--disabled-overlay-bg);\n  opacity: .5;\n  z-index: 9;\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
